;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import React, { ReactElement } from 'react';

import styles from '@/components/MultiLivestream/MultiLivestream.module.scss'

type MultiLivestreamErrorProps = {
  isIframe: boolean;
  stationName: string;
  scheduleUrl: string;
}

const MultiLivestreamError = (props: MultiLivestreamErrorProps): ReactElement => {
  const { isIframe, stationName, scheduleUrl } = props;

  return (
    <section className={styles.multi_livestream__error__container} data-sentry-component="MultiLivestreamError" data-sentry-source-file="MultiLivestreamError.tsx">
      <h3 className={styles.multi_livestream__error__title}>
        We&apos;re having trouble displaying the livestream schedule.
      </h3>
      <p className={styles.multi_livestream__error__body}>
        Please check back soon
        {scheduleUrl && (
          <span> or visit the
            <a
              className={styles.multi_livestream__error__link}
              href={scheduleUrl}
              target={ isIframe ? "_top" : "_blank"}
              rel="noopener noreferrer"
            >
              {stationName} On Air Schedule
            </a>
          </span>
        )}.
      </p>
      <p className={styles.multi_livestream__error__body}>
        For more information, visit our <a className={styles.multi_livestream__error__link} href="https://help.pbs.org/support/solutions/articles/12000069454-pbs-live-streaming-faq-and-troubleshooting">livestreaming FAQ</a>.
      </p>
    </section>
  );
}

export default MultiLivestreamError;
